import "./ButtonWithSubMenu.scss";

export default {
  root: "im-button-with-sub-menu",
  menu: "im-button-with-sub-menu__menu",
  list: "im-button-with-sub-menu__list",
  isOpened: "im-button-with-sub-menu--is-opened",
  floating: "im-button-with-sub-menu--floating",
  openedTopRight: "im-button-with-sub-menu--opened-top-right",
  openedTopLeft: "im-button-with-sub-menu--opened-top-left",
  openedBottomRight: "im-button-with-sub-menu--opened-bottom-right",
  openedBottomLeft: "im-button-with-sub-menu--opened-bottom-left",
};
